import { httpCreate } from './http';

const http = httpCreate('/srv/wedding');

export const wedding = {
	getBouquetList(activityId, params) {
		return http.get(`/bouquet-activity/activity/${activityId}`, { params });
	},
	createBouquet(activityId, data) {
		return http.post(`/bouquet-activity/${activityId}`, data);
	},
	modifyBouquet(bouquetId, data) {
		return http.put(`/bouquet-activity/${bouquetId}`, data);
	},
	readyBouquet(bouquetId) {
		return http.put(`/bouquet-activity/ready/${bouquetId}`);
	},
	clearBouquet(bouquetId) {
		return http.put(`/bouquet-activity/clear/${bouquetId}`);
	},
	startBouquet(bouquetId) {
		return http.post(`/bouquet-activity/start/${bouquetId}`);
	},
	deleteBouquet(bouquetId) {
		return http.delete(`/bouquet-activity/${bouquetId}`);
	},
	getParticipantList(activityId, params) {
		return http.get(`/bouquet-activity/participant/${activityId}`, { params });
	},
	getBouquetSelectList(activityId) {
		return http.get(`/bouquet-activity/activity/select/${activityId}`);
	},
	getInviteList(activityId) {
		return http.get(`/invitation-card/${activityId}`);
	},

	switchUseStatus(cardId, useStatus) {
		return http.put(`/invitation-card/switch/${cardId}/${useStatus}`);
	},
	addPage(cardId, data) {
		return http.post(`/invitation-card/page/${cardId}`, data);
	},
	editPage(pageId, data) {
		return http.put(`/invitation-card/page/${pageId}`, data);
	},
	getPageList(cardId) {
		return http.get(`/invitation-card/page/list/${cardId}`);
	},
	getPageConfig(cardId) {
		return http.get(`/invitation-card/config/${cardId}`);
	},
	editConfig(cardId, data) {
		return http.post(`/invitation-card/config/${cardId}`, data);
	},
};
